import cognitoAuth from "@/cognito";

export default (to, from, next) => {
  cognitoAuth.isAuthenticated((res, loggedIn) => {
    if (loggedIn) {
      console.log(1);
      return next();
    } else if (!loggedIn) {
      console.log(2);
      next("/login");
    }
  });
};
